import { cn } from '../lib/cn.ts'
import { MARK_BARS, MARK_VIEW_BOX } from '../lib/rally-mark-geometry.ts'

export interface RallyMarkProps {
  className?: string
  size?: number
  /**
   * Opt-in override for the center bar fill. Defaults to the oxide accent;
   * fully desaturated instances (e.g. the landing footer) pass
   * `currentColor` so every bar inherits the same ink.
   */
  accent?: string
}

// 2f "Repeater" mark. Bars inherit currentColor; the center bar takes the oxide
// accent unless an instance opts into a desaturated `accent`. Canonical grid and
// rules: docs/DESIGN_LANGUAGE.md §7 — never re-space, re-weight, round, or
// recolor beyond swapping currentColor.
// Decorative by design: every place this ships alongside the live "Rally" wordmark,
// so the mark stays out of the accessibility tree rather than double-announcing it.
export function RallyMark({ className, size = 22, accent = 'var(--color-signal-oxide)' }: RallyMarkProps) {
  return (
    <svg
      viewBox={`0 0 ${MARK_VIEW_BOX.width} ${MARK_VIEW_BOX.height}`}
      width={(size * MARK_VIEW_BOX.width) / MARK_VIEW_BOX.height}
      height={size}
      fill="none"
      aria-hidden="true"
      focusable="false"
      className={cn('shrink-0', className)}
    >
      {MARK_BARS.map((bar) => (
        <rect
          key={bar.x}
          x={bar.x}
          y={(MARK_VIEW_BOX.height - bar.h) / 2}
          width={bar.w}
          height={bar.h}
          fill={bar.center ? accent : 'currentColor'}
        />
      ))}
    </svg>
  )
}
